<div
  class="flex items-center gap-4 px-5 py-6 rounded-lg border border-primary-150 bg-primary-50 text-sm text-gray-700"
>
  <app-icon name="sapphire-info" size="xs" class="shrink-0 text-blue-500" />
  <span>
    Get your own knots and tags
    <app-link type="external" size="s" href="/">here</app-link>.
  </span>
</div>
